module.exports = __webpack_public_path__ + "km.svg?a45f5d0e9b751231f85d342cd38f7d41";